<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-bootbutton
            title="افزودن دسته بندی"
            type="primary"
            icon="fas fa-plus-square"
            btn-width="200px"
            @click.native="toggleForm"
            v-if="$acl.can('create', 'categories')"
          />
          <hr />
          <tree-list
            :data-source="categories"
            :filterable="true"
            :sortable="true"
            :columns="gridColumns"
            ref="grid"
          >
            <!-- <tree-list-column
              title="شناسه"
              field="id"
              :width="50"
            ></tree-list-column>
            <tree-list-column
              title="نام فارسی"
              field="name"
              :width="140"
            ></tree-list-column>
            <tree-list-column
              title="نام انگلیسی"
              field="slug"
              :width="140"
            ></tree-list-column>
            <tree-list-column
              title="تاریخ ایجاد"
              field="created_at"
              :template="
                (e) => (e.created_at ? $getJalaliDateTime(e.created_at) : '')
              "
              :width="140"
            ></tree-list-column> -->
          </tree-list>
          <!-- <bita-grid ref="grid" :columns="gridColumns" :read-data="readData" /> -->
        </div>
      </bita-ibox>
    </div>
    <category-form
      ref="form"
      :category="editForm"
      :categories="categories"
      :title="formTitle"
      :is-loading="isLoadingModal"
      @on-create="(e) => save(e)"
      @on-update="(e) => update(e)"
    />
  </div>
</template>
<script>
import { faqCategoryApi } from "@/api/apiManagement";
import {
  TreeList,
  TreeListColumn,
  TreeListInstaller,
} from "@progress/kendo-treelist-vue-wrapper";
import CategoryForm from "./components/CategoryForm.vue";

export default {
  use: [TreeListInstaller],
  // components: { "form-modal": faqForm },
  components: { TreeList, TreeListColumn, CategoryForm },

  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدیریت پرسش و پاسخ ها ",
          link: "/management/faq",
          active: true,
        },
      ],
      editForm: {},
      isLoadingGrid: false,
      isLoadingModal: false,
      formTitle: "",
      showForm: false,
      categories: [],
    };
  },
  computed: {
    gridColumns() {
      let commands = [];
      if (this.$acl.can("edit", "categories"))
        commands.push({
          text: "ویرایش",
          name: "my",
          click: this.editRow,
        });
      if (this.$acl.can("delete", "categories"))
        commands.push({
          text: "حذف",
          name: "delete",
          // template: this.gridButtons.delete,
          click: this.delete,
        });
      return [
        { field: "name", title: "نام فارسی" },
        { field: "slug", title: "نام انگلیسی" },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
        },
        {
          title: "عملیات",
          command: commands,
        },
      ];
    },
  },
  mounted() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      this.isLoadingGrid = true;
      // this.$resetGrid();
      faqCategoryApi
        .get()
        .then(({ data }) => {
          let categories = data.entity;
          for (let cat of categories) {
            cat.parentId =
              Number(cat.parent_id) == 0 ? null : Number(cat.parent_id);
          }
          this.categories = categories;
        })
        .catch(() => {})
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    save(_category) {
      this.isLoadingModal = true;
      _category = this.getFormData(_category);
      faqCategoryApi
        .create(_category)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);
          this.formSucceeded();
          this.$toggleModal("#category-form");
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },

    getFormData(data) {
      let formData = new FormData();
      for (var key in data) {
        if (data[key] != null) formData.append(key, data[key]);
      }
      return formData;
    },

    toggleForm() {
      this.formTitle = "افزودن دسته بندی";
      this.editForm = {};
      this.$toggleModal("#category-form");
    },

    editRow(e) {
      e.preventDefault();
      let grid = this.$refs.grid.kendoWidget();
      let category = grid.dataItem($(e.currentTarget).closest("tr"));
      this.isLoadingGrid = true;
      faqCategoryApi
        .get(category.id)
        .then((res) => {
          category = res.data.entity;
          this.editForm = {
            id: category.id,
            name: category.name,
            slug: category.slug,
            icon_url: category.icon_url,
            icon: category.icon,
            description: category.description || "",
            parent_id:
              category.parent_id > 0 ? String(category.parent_id) : null,
            title: category?.seo?.title,
            description_seo: category?.seo?.description,
            canonical: category?.seo?.canonical,
            tags: category.tag_names || [],
          };
          this.formTitle = `ویرایش گروه ${category.name}`;
          this.toggleForm();
        })
        .finally(() => (this.isLoadingGrid = false));
    },
    delete(e) {
      e.preventDefault();
      let grid = this.$refs.grid.kendoWidget();
      let category = grid.dataItem($(e.currentTarget).closest("tr"));
      this.$alert(
        "question",
        `آیا از حذف ${category.name} اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          faqCategoryApi
            .delete(category.id)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.getCategories();
            })
            .catch(() => (this.isLoadingGrid = false));
        }
      });
    },
    update(_category) {
      this.isLoadingModal = true;
      let formData = this.getFormData(_category);

      faqCategoryApi
        .update(_category.id, formData)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);
          this.formSucceeded();
        })
        .catch((err) => {
          this.$refs.form.setErrors(err.response.data.errors);
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    formSucceeded() {
      this.getCategories();
      this.formTitle = "";
      this.editForm = {};
      this.$refs.form.reset();
      this.$toggleModal("#category-form");
    },
  },
};
</script>
